var map = {
	"./Croissant_Logo.svg": 943,
	"./Croissant_Logo_text.svg": 567,
	"./back.svg": 656,
	"./croissant-logo-colour.png": 437,
	"./croissant-logo-grey.png": 592,
	"./croissant.png": 836,
	"./dots-vertical.svg": 392,
	"./heroicons/outline/document-download.svg": 995,
	"./heroicons/outline/exclamation-circle.svg": 453,
	"./heroicons/outline/plus-primary.svg": 548,
	"./heroicons/outline/plus-white.svg": 917,
	"./heroicons/outline/upload.svg": 310,
	"./heroicons/outline/user-circle-blue.svg": 102,
	"./logo-sm.png": 846,
	"./logo-transparent.png": 622,
	"./next.svg": 42,
	"./pencil.svg": 514,
	"./replace.svg": 347,
	"./skip_next.svg": 484,
	"./skip_previous.svg": 76,
	"./triangle-pointer.svg": 953
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 257;